<template>
  <div v-loading.fullscreen.lock="loading">
    <!-- 转库单提出 -->
    <el-dialog :title="$t('message.transferToLongTermStorageWarehouse')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1450px" center>
      <div class="content">
        <!-- 目标仓库： -->
        <div class="row">
          <div class="label">{{ $t("message.targetWarehouse") }}：</div>
          <div class="value">
            <!-- 长存仓库 -->
            <el-radio label="4" v-model="datas.target_shelf_type">{{ $t("message.longTermStorageWarehouse")
            }}</el-radio>
          </div>
        </div>
        <!-- 装箱操作人 -->
        <div class="row">
          <div class="label">{{ $t("message.packBy") }}：</div>
          <div class="value">
            <el-select v-model="datas.pack_by" clearable filterable :placeholder="$t('message.packBy')">
              <el-option v-for="item in z" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 整单操作备注 -->
        <div class="row">
          <div class="label">{{ $t("message.entireOrderOperationRemark") }}：</div>
          <div class="value">
            <el-input v-model="datas.remark" :placeholder="$t('message.entireOrderOperationRemark')" type="textarea" />
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!--  库位-->
            <li class="flex15">
              {{ $t("message.location") }}
            </li>
            <!--  订单号 -->
            <li class="flex15">
              {{ $t("message.orderNumber") }}
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--交易号/物流号  -->
            <li class="flex15">{{ $t("message.transactionNumberLogisticsNumber") }}</li>
            <!--可移库数  -->
            <li>{{ $t("message.movableQuantity") }}</li>
            <!-- 单番操作备注 -->
            <li class="flex15">{{ $t("message.singleOperationRemark") }}</li>
            <!-- 移库数量 -->
            <li>{{ $t("message.quantityOfWarehouseTransfer") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!--  库位-->
            <li class="flex15">
              <div class="template">
                <p>{{ item.grid_number.split("】-")[0] }}】-</p>
                <p style="color: #fa5058">
                  {{ item.grid_number.split("】-")[1] }}
                </p>
              </div>
            </li>
            <!--  订单号 -->
            <li class="flex15">
              <div class="template">
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' +
                    item.order_purchase.order_sn
                    " target="_blank" style="color: #fa5058">{{ item.order_purchase.order_sn }}</router-link>
                </p>
                <p>{{ item.order_purchase.order.user.realname }}</p>
              </div>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.order_purchase.order_detail.sorting }}
            </li>
            <!--照片-->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 60px; height: 60px" />
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--交易号/物流号  -->
            <li class="flex15">
              <div class="template">
                <p>JY:{{ item.order_purchase.purchase_no }}</p>
                <p v-for="(item, index) in item.order_purchase
                  .order_purchase_express" :key="index">
                  WL{{ index + 1 }}：{{ item.express_no }}
                </p>
              </div>
            </li>
            <!--库位数量  -->
            <li>{{ item.can_move_num }}</li>
            <!-- 单番操作备注 -->
            <li class="flex15">
              <el-input v-model="item.remark" type="textarea" resize="none"></el-input>
            </li>
            <!-- 移库数量 -->
            <li>
              <el-input v-model="item.yiku_num" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" type="number"
                onfocus="this.select()" @input="maxNum(item, index)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--重置-->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!--保存-->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      datas: {
        pack_by: "",
        remark: "",
        target_shelf_type: "4",
      }
    };
  },
  computed: {
    z() {
      return this.$store.state.authWorkGroupAdmin.z;
    },
  },
  methods: {
    // 最大废弃值
    maxNum(item, i) {
      if (item.yiku_num > item.can_move_num) {
        this.list[i].yiku_num = item.can_move_num;
        this.$message.error("移库数量不能大于库位数量");
      }
    },
    save() {
      this.datas.list = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].yiku_num == 0 || this.list[i].yiku_num == "") {
          this.$alert("移库数量不能为0或者为空", "提示", {
            confirmButtonText: "确定",
            center: true,
          });
          return;
        }
        this.datas.list.push({
          stock_id: this.list[i].id,
          num: this.list[i].yiku_num,
          remark: this.list[i].remark,
        });
      }
      this.$api.inventoryTransferApi.moveStore(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.stockList()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;

  .row {
    display: flex;
    margin-bottom: 24px;

    .label {
      width: 100px;
    }

    .value {
      flex: 1;

      /deep/.el-textarea__inner {
        height: 80px;
        resize: none;
      }
    }
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex18 {
      flex: 1.8;
    }

    ul {
      padding: 20px 0;

      /deep/.el-input {
        width: 80%;
      }

      .template {
        width: 100%;
        text-align: center;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 5px;

      .imgs {
        margin: 0 10px 10px 0px;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: 1px dashed #ccc;
        border-radius: 3px;

        /deep/.el-upload {
          width: 60px;
          height: 60px;
        }

        img {
          width: 100%;
          height: 100%;
        }

        &:nth-child(even) {
          margin-right: 0;
        }

        &:nth-child(n + 2) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>